import styled, {css} from 'styled-components';
import {device} from '../../styled/device';
import Datepicker from '../../components/acommon/FieldDatepicker';
import {Button} from '../../components/Button';

export const Title = styled.h2`
  text-align: center;
  color: #161643;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 20px;
  margin: 0 auto 8px;

  @media (max-width: ${device.laptop}) {
    font-size: 22px;
  }

  @media (max-width: ${device.mobileL}) {
    font-size: 22px;
    margin: 0 auto 5px;
  }
`;

export const Subtitle = styled.h3`
  text-align: center;
  font-family: Poppins-Regular, sans-serif;
  font-weight: 500;
  color: #777e90;
  font-size: 14px;
  margin: 0 auto 35px;

  @media (max-width: ${device.laptop}) {
    font-size: 18px;
  }

  @media (max-width: ${device.mobileL}) {
    font-size: 16px;
  }
`;

export const HorizontalLine = styled.div`
  display: none;

  @media (max-width: ${device.mobileXL}) {
    display: block;
    width: 98%;
    height: 1px;
    background: #00000024;
    margin: -22px auto 25px;
  }
`;

export const Container = styled.div`
  background: transparent linear-gradient(27deg, #fcfcfd 0%, #fcfcfded 100%) 0 0 no-repeat
    padding-box;
  box-shadow: 0 16px 64px #1f2f4666;
  border-radius: 24px;
  width: 100%;
  margin-top: 31px;
  padding: 38px 83px;

  @media (max-width: ${device.tablet}) {
    padding: 38px 30px;
  }

  @media (max-width: ${device.mobileXL}) {
    padding: 20px 10px;
    margin-top: 80px;
    margin-bottom: 40px;
    border-radius: 0;
    box-shadow: none;
    height: auto;

    & ${Title}, ${Subtitle} {
      text-align: left;
    }
  }
`;

export const Item = styled.div<{isVisible?: boolean; isMobileMode?: boolean}>`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${props =>
    props.isMobileMode &&
    !props.isVisible &&
    css`
      display: none;
    `}
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  gap: 50px;

  & ${Item}:nth-child(2) {
    display: flex;
    align-items: center;
    flex-direction: column;
    row-gap: 20px;
    font-family: Poppins-Regular, sans-serif;
    color: #777e90;
    font-size: 14px;

    @media (max-width: ${device.laptop}) {
      display: none;
    }
  }

  @media (max-width: ${device.laptop}) {
    flex-direction: column;
  }

  @media (max-width: ${device.mobileXL}) {
    margin-bottom: 20px;
  }
`;

export const VerticalLine = styled.div`
  height: 100%;
  width: 1px;
  background: #e2e7ef;
`;

export const SearchForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 25px;
  max-width: 288px;

  @media (max-width: ${device.mobileXL}) {
    max-width: 100%;
  }
`;

export const DatepickerInput = styled(Datepicker)`
  width: 100%;
`;

export const MobileAction = styled.div`
  display: none;

  & > p,
  div {
    font-family: Poppins-Medium, sans-serif;
    font-size: 20px;
    margin: 0;
  }

  @media (max-width: ${device.laptop}) {
    display: flex;
    flex-direction: column;
    text-align: center;
    font-family: ProximaNova-Medium, sans-serif;
    font-size: 23px;
    row-gap: 10px;
  }
`;

export const ButtonStyled = styled(Button)`
  height: auto;
  margin: 10px auto;
  font-family: Poppins-Medium, sans-serif;
  font-size: 20px;
  text-align: center;
  color: #2148ff;
  line-height: 1;

  @media (max-width: ${device.mobileXL}) {
    & > .buttonLabel {
      white-space: initial;
    }
  }
`;

export const ConfirmButton = styled(Button)`
  margin: 13px auto 0;
  justify-content: center;
  font-size: 20px;

  @media (max-width: ${device.mobileL}) {
    width: 100%;
  }
`;

export const GoBackButton = styled(Button)`
  margin: 10px auto 0;
  min-width: auto;
`;
